<h2 mat-dialog-title>Step Function 🤖</h2>
<mat-dialog-content class="mat-typography">
  <mat-form-field class="ai-settings-prompt-textarea">
    <mat-label>Prompt</mat-label>
    <textarea [(ngModel)]="functionData" matInput></textarea>
  </mat-form-field>

</mat-dialog-content>

<mat-dialog-actions align="end" style="margin-top: 100px;">
  <button mat-button autofocus (click)="close()">Cancel</button>
  <button mat-raised-button color="primary" (click)="save()">Save</button>
</mat-dialog-actions>
